import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
import { checkFilter } from "../../../Common/filterUtils";
import { bannerService } from "../../../Axios/bannerService";

export const getBanner = createAsyncThunk(
    'banner/getBanner',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await bannerService.getBanner(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitBanner = createAsyncThunk(
    'banner/submitBanner',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            data.title && formData.append('title', data.title);
            data.link && formData.append('link', data.link);
            data.photo && formData.append('photo', data.photo);

            let response;
            if (data.id) {
                response = await bannerService.updateBanner(data.id, formData);
            } else {
                response = await bannerService.createBanner(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteBanner = createAsyncThunk(
    'banner/deleteBanner',
    async (id, { rejectWithValue }) => {
        try {
            const response = await bannerService.deleteBanner(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
